'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDanger$002dAlert$0024$0024anon$002411 from "./presto.-Danger-Alert$$anon$11.js";
import * as $j_presto$002e$002dDanger$002dAlert$0024$0024anon$002412 from "./presto.-Danger-Alert$$anon$12.js";
import * as $j_presto$002e$002dDanger$002dAlert$0024$0024anon$002414 from "./presto.-Danger-Alert$$anon$14.js";
var $p;
/** @constructor */
function $c_Lpresto_DangerAlert$$anon$10() {
  this.aHA = null;
  this.aHy = null;
  this.aHz = false;
  this.aHw = null;
  this.aHx = false;
  this.aHB = false;
  this.aHC = false;
  this.aHA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_DangerAlert$$anon$10 as $c_Lpresto_DangerAlert$$anon$10 };
$p = $c_Lpresto_DangerAlert$$anon$10.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DangerAlert$$anon$10;
/** @constructor */
function $h_Lpresto_DangerAlert$$anon$10() {
}
export { $h_Lpresto_DangerAlert$$anon$10 as $h_Lpresto_DangerAlert$$anon$10 };
$h_Lpresto_DangerAlert$$anon$10.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aHA;
});
$p.t = (function() {
  if ((!this.aHz)) {
    this.aHy = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("SignDocumentErrorContext", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("UnifiedErrorContext", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aHz = true;
  }
  return this.aHy;
});
$p.ae = (function() {
  if ((!this.aHx)) {
    this.aHw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dDanger$002dAlert$0024$0024anon$002411.$c_Lpresto_DangerAlert$$anon$11(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dDanger$002dAlert$0024$0024anon$002412.$c_Lpresto_DangerAlert$$anon$12(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aHx = true;
  }
  return this.aHw;
});
$p.w = (function() {
  if ((!this.aHC)) {
    this.aHB = true;
    this.aHC = true;
  }
  return this.aHB;
});
$p.cDR = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeSum__I__O__Lio_circe_JsonObject(this, new $j_presto$002e$002dDanger$002dAlert$0024$0024anon$002414.$c_Lpresto_DangerAlert$$anon$14().cMx(a), a);
});
$p.ac = (function(a) {
  return this.cDR(a);
});
var $d_Lpresto_DangerAlert$$anon$10 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DangerAlert$$anon$10, "presto.DangerAlert$$anon$10", ({
  Gb: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_DangerAlert$$anon$10 as $d_Lpresto_DangerAlert$$anon$10 };
//# sourceMappingURL=presto.-Danger-Alert$$anon$10.js.map
